import React, {useMemo} from 'react';
import {Spinner} from '@/components/ui/spinner';
import {useToast} from '@/components/ui/toast';

export type LoadingContainerProps<T> = {
  error?: Error | null;
  loading: boolean;
  data?: T;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

export const LoadingContainer = (props: LoadingContainerProps<unknown>) => {
  const {showToast} = useToast();

  // Suppress errors while loading.
  const errorMessage = props.loading
    ? null
    : props.error
      ? props.error.message || `${props.error}`
      : null;

  useMemo(() => {
    if (errorMessage) {
      setTimeout(() => showToast(errorMessage, 'error'), 0);
    }
  }, [errorMessage, showToast]);

  return (
    <div
      style={props.style}
      className="flex items-center justify-center h-screen w-full"
    >
      {props.loading && <Spinner />}
      {!props.loading && props.children}
    </div>
  );
};
